import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-content-container overflow-hidden" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-6" }
const _hoisted_4 = { class: "col-md-6" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-md-8" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-sm-6" }
const _hoisted_9 = { class: "col-sm-6" }
const _hoisted_10 = { class: "col-sm-6" }
const _hoisted_11 = { class: "col-md-4" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_14 = { class: "card card-loading bg-white border-0 rounded-3 mb-4" }
const _hoisted_15 = {
  key: 1,
  class: "card-body p-4"
}
const _hoisted_16 = { class: "ps-0 mb-0 list-unstyled" }
const _hoisted_17 = { class: "d-flex align-items-center mb-2 pb-1" }
const _hoisted_18 = { class: "text-secondary fw-medium ms-1" }
const _hoisted_19 = {
  key: 1,
  class: "col-md-6"
}
const _hoisted_20 = { class: "card card-loading bg-white border-0 rounded-3 mb-4" }
const _hoisted_21 = {
  key: 1,
  class: "card-body p-4"
}
const _hoisted_22 = { class: "ps-0 mb-0 list-unstyled" }
const _hoisted_23 = { class: "d-flex align-items-center mb-2 pb-1" }
const _hoisted_24 = { class: "text-secondary fw-medium ms-1" }
const _hoisted_25 = { class: "d-flex align-items-center mb-2 pb-1" }
const _hoisted_26 = { class: "text-secondary fw-medium ms-1" }
const _hoisted_27 = { class: "d-flex align-items-center mb-2 pb-1" }
const _hoisted_28 = { class: "text-secondary fw-medium ms-1" }
const _hoisted_29 = { class: "col-md-6" }
const _hoisted_30 = { class: "card card-loading bg-white border-0 rounded-3 mb-4" }
const _hoisted_31 = {
  key: 1,
  class: "card-body p-4"
}
const _hoisted_32 = { class: "ps-0 mb-0 list-unstyled" }
const _hoisted_33 = { class: "d-flex align-items-center mb-2 pb-1" }
const _hoisted_34 = { class: "text-secondary fw-medium ms-1" }
const _hoisted_35 = { class: "d-flex align-items-center mb-2 pb-1" }
const _hoisted_36 = { class: "text-secondary fw-medium ms-1" }
const _hoisted_37 = { class: "d-flex align-items-center mb-2 pb-1" }
const _hoisted_38 = { class: "text-secondary fw-medium ms-1" }
const _hoisted_39 = { class: "d-flex align-items-center mb-2 pb-1" }
const _hoisted_40 = { class: "text-secondary fw-medium ms-1" }
const _hoisted_41 = { class: "d-flex align-items-center mb-2 pb-1" }
const _hoisted_42 = { class: "text-secondary fw-medium ms-1" }
const _hoisted_43 = { class: "d-flex align-items-center mb-2 pb-1" }
const _hoisted_44 = { class: "text-secondary fw-medium ms-1" }
const _hoisted_45 = {
  key: 2,
  class: "col-md-6"
}
const _hoisted_46 = { class: "card card-loading bg-white border-0 rounded-3 mb-4" }
const _hoisted_47 = {
  key: 1,
  class: "card-body p-4"
}
const _hoisted_48 = { class: "ps-0 mb-0 list-unstyled" }
const _hoisted_49 = { class: "d-flex align-items-center mb-2 pb-1" }
const _hoisted_50 = { class: "text-secondary fw-medium ms-1" }
const _hoisted_51 = { class: "d-flex align-items-center mb-2 pb-1" }
const _hoisted_52 = { class: "text-secondary fw-medium ms-1" }
const _hoisted_53 = { class: "d-flex align-items-center mb-2 pb-1" }
const _hoisted_54 = { class: "text-secondary fw-medium ms-1" }
const _hoisted_55 = { class: "d-flex align-items-center mb-2 pb-1" }
const _hoisted_56 = { class: "text-secondary fw-medium ms-1" }
const _hoisted_57 = { class: "d-flex align-items-center mb-2 pb-1" }
const _hoisted_58 = { class: "text-secondary fw-medium ms-1" }
const _hoisted_59 = { class: "d-flex align-items-center mb-2 pb-1" }
const _hoisted_60 = { class: "text-secondary fw-medium ms-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RequisitionOverview = _resolveComponent("RequisitionOverview")!
  const _component_RequisitionChart = _resolveComponent("RequisitionChart")!
  const _component_TotalUser = _resolveComponent("TotalUser")!
  const _component_TotalItem = _resolveComponent("TotalItem")!
  const _component_TotalVessel = _resolveComponent("TotalVessel")!
  const _component_ItemByCategory = _resolveComponent("ItemByCategory")!
  const _component_BaseLoading = _resolveComponent("BaseLoading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_RequisitionOverview)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_RequisitionChart)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _withDirectives(_createVNode(_component_TotalUser, {
              total: _ctx.generalData?.user_total?.total
            }, null, 8, ["total"]), [
              [_vShow, _ctx.checkPermission('total-user')]
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _withDirectives(_createVNode(_component_TotalItem, {
              total: _ctx.generalData?.item_total?.total
            }, null, 8, ["total"]), [
              [_vShow, _ctx.checkPermission('total-item')]
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _withDirectives(_createVNode(_component_TotalVessel, {
              total: _ctx.generalData?.vessel_total?.total
            }, null, 8, ["total"]), [
              [_vShow, _ctx.checkPermission('total-vessel')]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_ItemByCategory)
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      (!_ctx.isAdmin)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              (_ctx.isLoading)
                ? (_openBlock(), _createBlock(_component_BaseLoading, { key: 0 }))
                : _createCommentVNode("", true),
              (!_ctx.isLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _cache[1] || (_cache[1] = _createElementVNode("h3", { class: "mb-3 mb-lg-4" }, "Ship Owner", -1)),
                    _createElementVNode("ul", _hoisted_16, [
                      _createElementVNode("li", _hoisted_17, [
                        _cache[0] || (_cache[0] = _createElementVNode("span", null, "Name:", -1)),
                        _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.loginInfo?.ship_owner_company?.name), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      (!_ctx.isAdmin)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              (_ctx.isLoading)
                ? (_openBlock(), _createBlock(_component_BaseLoading, { key: 0 }))
                : _createCommentVNode("", true),
              (!_ctx.isLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _cache[5] || (_cache[5] = _createElementVNode("h3", { class: "mb-3 mb-lg-4" }, "Ship Management Company", -1)),
                    _createElementVNode("ul", _hoisted_22, [
                      _createElementVNode("li", _hoisted_23, [
                        _cache[2] || (_cache[2] = _createElementVNode("span", null, "Name:", -1)),
                        _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.loginInfo?.ship_management_company?.name), 1)
                      ]),
                      _createElementVNode("li", _hoisted_25, [
                        _cache[3] || (_cache[3] = _createElementVNode("span", null, "Registration Number:", -1)),
                        _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.loginInfo?.ship_management_company?.reg_no), 1)
                      ]),
                      _createElementVNode("li", _hoisted_27, [
                        _cache[4] || (_cache[4] = _createElementVNode("span", null, "Country:", -1)),
                        _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.loginInfo?.ship_management_company?.country), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          (_ctx.isLoading)
            ? (_openBlock(), _createBlock(_component_BaseLoading, { key: 0 }))
            : _createCommentVNode("", true),
          (!_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                _cache[12] || (_cache[12] = _createElementVNode("h3", { class: "mb-3 mb-lg-4" }, "Profile Information", -1)),
                _createElementVNode("ul", _hoisted_32, [
                  _createElementVNode("li", _hoisted_33, [
                    _cache[6] || (_cache[6] = _createElementVNode("span", null, "Username:", -1)),
                    _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.loginInfo?.user?.username), 1)
                  ]),
                  _createElementVNode("li", _hoisted_35, [
                    _cache[7] || (_cache[7] = _createElementVNode("span", null, "Full Name:", -1)),
                    _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.loginInfo?.user?.name), 1)
                  ]),
                  _createElementVNode("li", _hoisted_37, [
                    _cache[8] || (_cache[8] = _createElementVNode("span", null, "Phone:", -1)),
                    _createElementVNode("span", _hoisted_38, "+" + _toDisplayString(_ctx.loginInfo?.user?.phone_code + _ctx.loginInfo?.user?.phone), 1)
                  ]),
                  _createElementVNode("li", _hoisted_39, [
                    _cache[9] || (_cache[9] = _createElementVNode("span", null, "Role:", -1)),
                    _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.loginInfo?.role?.name), 1)
                  ]),
                  _createElementVNode("li", _hoisted_41, [
                    _cache[10] || (_cache[10] = _createElementVNode("span", null, "Role Group:", -1)),
                    _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.loginInfo?.role_group?.name), 1)
                  ]),
                  _createElementVNode("li", _hoisted_43, [
                    _cache[11] || (_cache[11] = _createElementVNode("span", null, "Designation:", -1)),
                    _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.loginInfo?.job?.name), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      (!_ctx.isAdmin)
        ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
              (_ctx.isLoading)
                ? (_openBlock(), _createBlock(_component_BaseLoading, { key: 0 }))
                : _createCommentVNode("", true),
              (!_ctx.isLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                    _cache[19] || (_cache[19] = _createElementVNode("h3", { class: "mb-3 mb-lg-4" }, "Vessel Information", -1)),
                    _createElementVNode("ul", _hoisted_48, [
                      _createElementVNode("li", _hoisted_49, [
                        _cache[13] || (_cache[13] = _createElementVNode("span", null, "Name:", -1)),
                        _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.loginInfo?.vessel?.name), 1)
                      ]),
                      _createElementVNode("li", _hoisted_51, [
                        _cache[14] || (_cache[14] = _createElementVNode("span", null, "Call Sign:", -1)),
                        _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.loginInfo?.vessel?.call_sign), 1)
                      ]),
                      _createElementVNode("li", _hoisted_53, [
                        _cache[15] || (_cache[15] = _createElementVNode("span", null, "Class:", -1)),
                        _createElementVNode("span", _hoisted_54, _toDisplayString(_ctx.loginInfo?.vessel?.vesselClass?.name), 1)
                      ]),
                      _createElementVNode("li", _hoisted_55, [
                        _cache[16] || (_cache[16] = _createElementVNode("span", null, "Type:", -1)),
                        _createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.loginInfo?.vessel?.vesselType?.name), 1)
                      ]),
                      _createElementVNode("li", _hoisted_57, [
                        _cache[17] || (_cache[17] = _createElementVNode("span", null, "IMO:", -1)),
                        _createElementVNode("span", _hoisted_58, _toDisplayString(_ctx.loginInfo?.vessel?.imo), 1)
                      ]),
                      _createElementVNode("li", _hoisted_59, [
                        _cache[18] || (_cache[18] = _createElementVNode("span", null, "MMSI:", -1)),
                        _createElementVNode("span", _hoisted_60, _toDisplayString(_ctx.loginInfo?.vessel?.mmsi), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}